<template>
  <v-container fluid>
    <v-tabs color="transparent" v-model="tab" show-arrows>
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab v-for="tabItem in tabs" :key="tabItem">
        {{ $t(tabItem) }}
      </v-tab>
      <v-layout justify-center align-center>
        <v-btn dark color="primary" @click="showExportOrdersPopup">
          {{ $t('exportOrders') }}
        </v-btn>
      </v-layout>
      <v-layout justify-center align-center>
        <v-flex v-if="currentTab === 'active' && fulfillmentOrders && fulfillmentOrders.length" style="white-space: nowrap; text-align: center; cursor: pointer;" @click="tab = 2">
          <v-icon color="orange">info</v-icon>
          <span style="color: dodgerblue; text-decoration: underline;">
            You have orders in fulfill page
          </span>
        </v-flex>
      </v-layout>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item v-for="(item, index) in tabs" :key="index">
          <div v-if="item === 'active' && currentTab === 'active'">
            <v-layout justify-space-between>
              <v-flex xs6 md12 xl8>
                <v-layout>
                  <UploadFileWidget
                    v-model="uploadedFiles"
                    ref="fileUploader"
                    style="max-width: 150px;"
                    type="order"
                    :maxFiles="1"
                    :clearFiles="clearFiles"
                    small
                    :loading="loading"
                    @filesStatus="
                      status => status === 'done' && uploadedFiles.length && uploadOrders()
                    "
                    >{{ $t('uploadOrders') }}</UploadFileWidget
                  >
                  <vite-module-container :moduleNames="['shipment']" v-if="!isOrgLabel">
                    <v-btn
                      color="primary"
                      :loading="buyShippingDialogRunning"
                      @click="showBuyShippingDialog()"
                      :disabled="
                        selectedOrders.length === 0 ||
                        isMPSOrder ||
                        buyShippingDialogRunning
                      "
                    >
                      {{ $t('createShipments') }}({{
                        selectedOrders.length - selectedMPSOrdersLen
                      }})
                    </v-btn>
                  </vite-module-container>
                  <v-btn
                    color="primary"
                    :loading="buyLabelDialogRunning"
                    @click="showBuyLabelDialog()"
                    :disabled="
                      selectedOrders.length === 0 ||
                      isMPSOrder ||
                      buyLabelDialogRunning
                    "
                  >
                    {{ $t('createLabels') }}({{
                      selectedOrders.length - selectedMPSOrdersLen
                    }})
                  </v-btn>
                  <v-menu offset-y :class="'hidden-sm-and-down'">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        @click.stop="on.click"
                        :disabled="
                          selectedMPSOrdersLen === 0 ||
                          buyShippingDialogRunning
                        "
                        color="primary"
                      >
                        {{ $t('createMPSLabel') }}({{
                          selectedMPSOrdersLen
                        }})
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile>
                        <v-btn
                          flat
                          :loading="buyLabelDialogRunning"
                          @click="showBuyLabelDialog(true)"
                          :disabled="
                            selectedOrders.length === 0 ||
                            selectedOrders.every(order => !order.isMPS) ||
                            buyLabelDialogRunning
                          "
                        >
                          {{ $t('createMPSLabels') }}({{
                            selectedMPSOrdersLen
                          }})
                        </v-btn>
                      </v-list-tile>
                      <template>
                        <vite-module-container :moduleNames="['shipment']">
                          <v-list-tile>
                            <v-btn
                              flat
                              :loading="buyShippingDialogRunning"
                              @click="showBuyShippingDialog(true)"
                              :disabled="
                                selectedOrders.length === 0 ||
                                selectedOrders.every(order => !order.isMPS) ||
                                buyLabelDialogRunning
                              "
                            >
                              {{ $t('createMPSShipments') }}({{
                                selectedMPSOrdersLen
                              }})
                            </v-btn>
                          </v-list-tile>
                        </vite-module-container>
                      </template>
                    </v-list>
                  </v-menu>
                  <v-btn
                    color="primary"
                    @click="batchCancel"
                    :disabled="selectedOrders.length === 0"
                  >
                    {{ $t('cancel/archiveSelected') }}
                  </v-btn>
                  <v-flex md3 style="min-width: 10rem">
                    <v-select
                      :items="stores"
                      item-text="accountName"
                      v-model="storePullOrders"
                      :label="$t('selectStorePullOrders')"
                      clearable
                      multiple
                      return-object
                    ></v-select>
                  </v-flex>
                  <v-tooltip right>
                    <template v-slot:activator="tooltip">
                      <div v-on="tooltip.on">
                        <v-btn
                          color="primary"
                          :disabled="pullOrderLastTimeDisabled || isDisabledPullOrder"
                          :loading="processEcomLoading"
                          @click="pullOrders(storePullOrders)"
                        >
                          {{ $t('pullOrder') }}
                          <v-icon v-if="pullOrderUpdateLoading" dark class="mx-2 loading"
                            >hourglass_empty</v-icon
                          >
                        </v-btn>
                      </div>
                    </template>
                    <span v-if="isDisabledPullOrder">
                      {{ $t('selectStorePullOrders') }}
                    </span>
                    <span v-else>
                      <template v-for="storePullOrder in storePullOrders">
                        {{ storePullOrder.accountName }}
                        <br :key="`${storePullOrder.accountId}-1`"/>
                        {{
                          `${$t('orderLastRequestTime')}：${
                            storePullOrder && (storePullOrder.orderLastRequestTime || storePullOrder.orderLastUpdateTime)
                              ? toTimestampString(
                                  new Date(
                                    storePullOrder.orderLastRequestTime ||
                                      storePullOrder.orderLastUpdateTime
                                  )
                                )
                              : 'N/A'
                          }`
                        }}
                        <br :key="`${storePullOrder.accountId}-2`"/>
                        {{
                          `${$t('orderLastUpdateTime')}：${
                            storePullOrder && storePullOrder.orderLastUpdateTime
                              ? toTimestampString(new Date(storePullOrder.orderLastUpdateTime))
                              : 'N/A'
                          }`
                        }}
                        <br :key="`${storePullOrder.accountId}-3`"/>
                        {{
                          storePullOrder && storePullOrder.pullOrderErrorMessage
                            ? `${$t('pullOrderErrorMessage')}：${$t(
                                `EcomRequestError.${storePullOrder.pullOrderErrorMessage}`
                              )}`
                            : ''
                        }}
                      </template>
                      <br />
                      {{ $t('pullOrderCDTime', { pullOrderCDTime }) }}
                    </span>
                  </v-tooltip>
                </v-layout>
              </v-flex>
              <v-flex xs4 md2>
                <v-text-field
                  append-icon="filter_list"
                  :label="$t('search')"
                  single-line
                  hide-details
                  v-model="filter"
                  clearable
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout justify-center mb-3 mt-2 v-if="errorAlert || alert">
              <v-flex xs12 md10>
                <v-alert v-model="errorAlert" dismissible outline type="error">{{
                  errorMessage
                }}</v-alert>
                <v-alert
                  :value="alert"
                  dismissible
                  outline
                  :type="alertType"
                  :style="{
                    whiteSpace: 'pre-wrap',
                  }"
                  >{{ alertMsg }}</v-alert
                >
              </v-flex>
            </v-layout>
            <!-- Can be extend to independent component for "select while click row" in the future -->
            <v-layout justify-start>
              <v-flex class="success--text caption" xs2>
                <span class="realtime-border px-1">{{ $t('realTIME') }}</span>
                <span v-if="orders.length < orderQtyLimit" class="realtime-border px-1">{{ $t('orderQty', {quantity: orders.length}) }}</span>
                <span v-else class="realtime-border px-1">{{ $t('orderQty', {quantity: orderQtyLimit}) + '+' }}</span>
              </v-flex>
              <v-flex>
                {{ $t('supportAmazon/ebay/walmart/newegg/')}}
                <a linkify @click="getStandTemplate()">{{ $t('standard') }} / </a>
                <a linkify @click="getStandTemplate(true)">MPSstandard</a>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs2>
                <DatePicker
                  v-model="dates"
                  :label="$t('date')"
                  range
                  :max="activeDateMax"
                  :min="activeDateMin"
                />
              </v-flex>
              <!-- <v-flex xs2>
                <v-btn
                  color="primary"
                  :disabled="!selectedFilteredOrders.length"
                  @click="cancelOrders(selectedFilteredOrders)"
                  :loading="cancelLoading"
                >
                  {{ $t('cancelOrder') }} ({{ selectedFilteredOrders.length }})
                </v-btn>
              </v-flex> -->
            </v-layout>
            <v-data-table
              v-if="item === 'active' && currentTab === 'active'"
              :headers="headers"
              :search="filter"
              :items="orders"
              select-all="blue"
              v-model="selectedFilteredOrders"
              :pagination.sync="pagination"
              item-value="_indexKey"
              item-key="_indexKey"
              ref="activeOrders"
              :rows-per-page-items="rowPerPage"
              :expand="expand"
            >
              <template v-slot:headers="props">
                <tr class="active-headers">
                  <td
                    class="checkbox-align-center"
                  >
                    <v-layout>
                      <v-checkbox
                        @click.stop="toggleAll"
                        :value="props.all"
                        primary
                        hide-details
                        :indeterminate="!!selectedOrders.length"
                      ></v-checkbox>
                    </v-layout>
                  </td>
                  <td style="width:15%">
                    <v-layout align-center @click="sortOrders('purchaseDate')">
                      <v-flex class="header-date">
                        {{ $t('orderDate') }}
                        <template v-if="sortTable.param === 'purchaseDate'">
                          <v-icon :class="{ 'header-date-arrow-desc': sortTable.type === 'desc'}" size="14">arrow_upward</v-icon>
                        </template>
                      </v-flex>
                    </v-layout>
                    <v-layout align-center @click="sortOrders('updateDate')">
                      <v-flex class="header-date">
                        {{ $t('updateTime') }}
                        <template v-if="sortTable.param === 'updateDate'">
                          <v-icon :class="{ 'header-date-arrow-desc': sortTable.type === 'desc'}" size="14">arrow_upward</v-icon>
                        </template>
                      </v-flex>
                    </v-layout>
                  </td>
                  <td style="width:10%" class="text-align-center">
                    <v-layout>{{ $t('orderDetail') }}</v-layout>
                  </td>
                  <td class="text-align-center">
                    <v-layout>{{ $t('productInfo') }}</v-layout>
                  </td>
                  <td class="text-align-center">
                    <v-layout>{{ $t('buyerInfo') }}</v-layout>
                  </td>
                  <td class="text-align-center">
                    <v-layout>{{ $t('serviceLevel/AddressType') }}</v-layout>
                  </td>
                  <td class="text-justify-center">
                    <v-layout justify-center>{{ $t('template') }}</v-layout>
                  </td>
                  <td class="text-justify-center" style="width:10%">
                    <v-layout justify-center>{{ $t('actions') }}</v-layout>
                  </td>
                </tr>
              </template>
              <template v-slot:items="props">
                <td
                  class="checkbox-align-center"
                  @click="!props.item.isDisabled && (props.selected = !props.selected)"
                >
                  <v-layout>
                    <v-checkbox
                      :disabled="props.item.isDisabled"
                      @click.stop="
                        () => {
                          props.selected = !props.selected
                        }
                      "
                      :value="props.selected"
                      primary
                      hide-details
                    ></v-checkbox>
                  </v-layout>
                </td>
                <td class="text-xs-left">{{ toTimestampString(props.item.purchaseDate) }}<br/>{{ toTimestampString(props.item.updateDate) }}</td>
                <td class="text-xs-left">
                  <OrderDetail
                    :orderType="props.item.isMPS"
                    :storeName="props.item.storeName"
                    :orderId="props.item.orderName || props.item.orderId"
                    :platform="props.item.platform"
                    :messages="props.item.messages"
                    :orderStatus="props.item.cancelState"
                  />
                  <v-layout v-if="!!props.item.error" justify-start wrap align-start>
                    <span style="color: red;">Shipment Error: {{ props.item.error.message }}</span>
                  </v-layout>
                </td>
                <td class="text-xs-left">
                  <v-flex row v-for="(item, index) in props.item.items" :key="item.sku + index">
                    <ProductWidget
                      :name="item.productName"
                      :sku="[item.sku]"
                      :quantityShipped="item.quantityShipped"
                      :quantityPurchased="item.quantityPurchased"
                      :status="item.productStatus"
                      :isMatchingExactly="props.item.exactMatchTemplate"
                      @submit-quantity="(value) => updateQuantity(props.item.orderId, item.orderItemId, value)"
                      isSupportChanged
                    >
                      <template v-slot:sku>
                        <span class="ml-2"
                          ><a
                            @click="
                              () => {
                                filter = item.sku
                              }
                            "
                            >{{ item.sku }}</a
                          ></span
                        >
                      </template>
                    </ProductWidget>

                    <v-layout>
                      <v-flex class="text-sm-left"
                        >{{ $t('shipBy') }}: {{ toDateString(props.item.promiseDate) }}</v-flex
                      >
                    </v-layout>
                  </v-flex>
                </td>
                <td class="text-xs-left">
                  <v-layout>
                    <strong>{{ props.item.buyerName }}</strong>
                  </v-layout>
                  <v-layout>
                    {{ props.item.recipientName }}
                  </v-layout>
                  <v-layout>
                    {{ props.item.shipAddress1 + props.item.shipAddress2 }}
                  </v-layout>
                  <v-layout>
                    {{ props.item.shipCity }} - {{ props.item.shipState }} -
                    {{ props.item.shipPostalCode }}
                  </v-layout>
                  <v-layout>
                    {{ props.item.buyerPhoneNumber }}
                  </v-layout>
                  <v-layout v-if="props.item.buyerNotes">
                    {{ props.item.buyerNotes }}
                  </v-layout>
                </td>
                <td class="text-xs-left">
                  <v-layout>
                    <span
                      :style="`color: ${
                        props.item.shipServiceLevel === 'ShippingMethodExpress' ||
                        props.item.platform === 'Amazon' && props.item.shipServiceLevel  === 'NextDay'  ||
                        props.item.platform === 'Amazon' && props.item.shipServiceLevel === 'SecondDay'  ||
                        props.item.shipServiceLevel === 'Express'
                          ? 'red'
                          : 'black'
                      }`"
                      >{{ props.item.shipServiceLevel }}</span
                    >
                    <span>/{{ props.item.isBusinessOrder ? $t('business') : $t('other') }}</span>
                  </v-layout>
                </td>
                <!-- templates.find(template => props.item.items.some(item => item.sku === template.sku && (item.quantity === template.quantity || 1))).name -->
                <!-- findCorrectTemplate(props.item.items) -->
                <td
                  class="text-xs-center"
                  v-if="
                    templates.find(
                      template =>
                        props.item.items.length === 1 &&
                        props.item.items.some(
                          item => item.sku === template.sku || template.sku.includes(item.sku)
                        )
                    ) && props.item.matchedTemplateName
                  "
                >
                  <v-tooltip top>
                    <template v-slot:activator="tooltip">
                      <div
                        v-on="tooltip.on"
                        :style="{ background: props.item.exactMatchTemplate ? '' : 'yellow' }"
                      >
                        <span>{{ props.item.matchedTemplateName }}</span>
                      </div>
                    </template>
                    {{
                      props.item.exactMatchTemplate
                        ? $t('skuAndQtyAllMatched')
                        : $t('skuMatchedQtyUnmatch')
                    }}
                  </v-tooltip>
                </td>
                <td class="text-xs-center" v-else-if="props.item.items.length === 1">
                  <v-btn
                    @click.stop="showTemplateDialog(props.item)"
                    dark
                    flat
                    icon
                    color="primary"
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                </td>
                <td class="text-xs-left" v-else></td>
                <td class="text-xs-center">
                  <v-layout justify-center no-wrap>
                    <v-tooltip top v-if="!props.item.isApiOrder">
                      <template v-slot:activator="tooltip">
                        <div v-on="tooltip.on">
                          <v-btn
                            icon
                            flat
                            dark
                            color="primary"
                            @click="showRevisePkg(props.item)"
                          >
                            <v-icon>widgets</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      {{ $t('modifyPkgSpecification') }}
                    </v-tooltip>

                    <v-tooltip top v-if="!isOrgLabel">
                      <template v-slot:activator="tooltip">
                        <div v-on="tooltip.on">
                          <vite-module-container :moduleNames="['shipment']">
                            <v-btn
                              @click="showAddShipmentSingle(props.item)"
                              dark
                              flat
                              icon
                              color="primary"
                            >
                              <v-icon>local_shipping</v-icon>
                            </v-btn>
                          </vite-module-container>
                        </div>
                      </template>
                      {{ $t('addShipmentFromOrder') }}
                    </v-tooltip>

                    <v-tooltip top v-if="props.item.items.some(item => item.quantityShipped > 0)">
                      <template v-slot:activator="tooltip">
                            <div v-on="tooltip.on">
                              <v-btn
                                  icon
                                  flat
                                  dark
                                  color="primary"
                                  :loading="props.item.archiveLoading"
                                  @click="archiveOrder(props.item)"

                                >
                                  <v-icon>archive</v-icon>
                                </v-btn>
                            </div>
                      </template>
                              {{ $t('archiveOrder') }}
                    </v-tooltip>

                    <v-tooltip top v-else>
                      <template v-slot:activator="tooltip">
                        <div v-on="tooltip.on">
                          <v-btn icon flat dark color="primary" :loading="props.item.loading" @click="cancelOrder(props.item)">
                            <v-icon>cancel</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      {{ $t('cancelOrder') }}
                    </v-tooltip>

                    <v-tooltip top>
                      <template v-slot:activator="tooltip">
                        <div v-on="tooltip.on">
                          <v-btn icon flat dark color="primary" @click="showRemarkOrderPopup(props.item)">
                            <v-icon>note</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      {{ $t('remarkOrder') }}
                    </v-tooltip>

                    <v-tooltip top>
                      <template v-slot:activator="tooltip">
                        <div v-on="tooltip.on">
                          <v-btn icon flat dark color="primary" @click="showSplitOrderPopup(props.item)">
                            <v-icon style="transform: rotate(90deg);">splitscreen</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      {{ $t('splitOrder') }}
                    </v-tooltip>
                  </v-layout>
                </td>
            </template>
            </v-data-table>
          </div>
          <div v-if="item === 'pendingShipment' && currentTab === 'pendingShipment'">
            <v-layout layout align-content-space-around>
              <v-flex mb-3 md10>
                <v-layout>
                  <v-btn
                    :disabled="enabledSelectedShipmentOrders.length === 0 || processOrderShipmentLoading"
                    :loading="processOrderShipmentLoading"
                    @click="retryOrderShipment(enabledSelectedShipmentOrders)"
                    color="primary"
                    >{{ $t('retry') }} ({{ enabledSelectedShipmentOrders.length }})</v-btn
                  >
                </v-layout>
              </v-flex>
              <v-flex xs4 md2>
                <v-text-field
                  append-icon="filter_list"
                  :label="$t('search')"
                  single-line
                  hide-details
                  v-model="filter"
                  clearable
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout justify-start>
              <v-flex class="success--text caption" xs2>
                <span class="realtime-border px-1">{{ $t('realTIME') }}</span>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="shipmentHeaders"
              :items="shipmentOrders.filter(item => filter ? item.orderId.includes(filter) : true)"
              item-key="_key"
              v-model="selectedShipmentOrders"
              select-all="blue"
              :expand="expand"
              :pagination.sync="pagination"
              :rows-per-page-items="rowPerPage"
            >
              <template v-slot:items="props">
                <td class="checkbox-align-center"
                @click="() => {
                  !props.item.isDisabled && (props.selected = !props.selected)
                  if (props.item.isDisabled) {
                    props.selected = false
                  }
                }"
                >
                  <v-layout>
                    <v-checkbox
                      @click.stop="
                        () => {
                          props.selected = !props.selected
                        }
                      "
                      :disabled="props.item.isDisabled"
                      :value="props.selected"
                      primary
                      hide-details
                    ></v-checkbox>
                  </v-layout>
                </td>
                <td class="text-xs-left">
                  <OrderDetail
                    :orderId="props.item.orderId"
                    :platform="props.item.platform"
                    :messages="props.item.messages || []"
                    :storeName="props.item.storeName"
                  />
                  <v-layout justify-start wrap align-start>
                    <span
                      >{{ $t('orderDate') }}: {{ toTimestampString(props.item.purchaseDate) }}</span
                    >
                  </v-layout>
                  <v-layout justify-start wrap align-start>
                    <span
                      >{{ $t('processDate') }}:
                      {{ toTimestampString(props.item.processTime) }}</span
                    >
                  </v-layout>
                </td>
                <td class="text-xs-left">
                  <LabelAddressWidget :address="props.item.label && props.item.label.from" />
                </td>
                <td class="text-xs-left">
                  <LabelAddressWidget :address="props.item.label && props.item.label.to" />
                </td>
                <td class="text-xs-left">
                  <div style="color: red" v-if="props.item.processStatus === 'failed'">
                    {{ $t(props.item.error ? props.item.error.message : '') }}
                  </div>
                </td>
                <td class="text-xs-left">
                  {{ $t(props.item.processStatus) }}
                </td>
                <td class="text-xs-left">
                  <v-menu offset-y v-if="props.item.processStatus === 'failed'">
                    <template v-slot:activator="{ on }">
                      <v-tooltip top>
                        <template v-slot:activator="tooltip">
                          <div v-on="tooltip.on">
                            <v-btn @click.stop="on.click" dark icon flat color="primary">
                              <v-icon>build</v-icon>
                            </v-btn>
                          </div>
                        </template>
                        {{ $t('more') }}
                      </v-tooltip>
                    </template>
                    <v-list>
                      <v-list-tile
                        class="list-tile-center"
                      >
                        <LoaderButton
                          flat
                          :buttonText="$t('edit')"
                          :disabled="props.item.isDisabled"
                          :promiseAwait="editLabel"
                          :promiseItem="props.item"
                        ></LoaderButton>
                      </v-list-tile>
                    </v-list>
                    <v-list>
                      <v-list-tile
                        class="list-tile-center"
                      >
                        <LoaderButton
                          flat
                          :disabled="props.item.isDisabled"
                          :buttonText="$t('delete')"
                          :promiseAwait="deleteShipmentTask"
                          :promiseItem="props.item"
                        ></LoaderButton>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </td>
              </template>
            </v-data-table>
          </div>
          <div v-if="item === 'fulfillment' && currentTab === 'fulfillment'">
            <v-layout layout align-content-space-around>
              <v-flex mb-3 md10>
                <v-layout>
                  <v-tooltip bottom>
                    <template v-slot:activator="tooltip">
                      <div v-on="tooltip.on">
                        <v-btn
                          :disabled="selectedFulfillments.length === 0"
                          :loading="processEcomLoading"
                          @click="markFulfillment(selectedFulfillments)"
                          color="primary"
                          >{{ $t('fulfill') }} ({{ selectedFulfillments.length }})</v-btn
                        >
                      </div>
                    </template>
                    {{ $t('submitFulfillment') }}
                  </v-tooltip>
                  <v-menu offset-y :class="'hidden-sm-and-down'">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        @click.stop="on.click"
                        :disabled="selectedFulfillments.length === 0"
                        :loading="reverseFulfillLoading || closeFulfillLoading"
                        color="primary"
                      >
                        {{ $t('more') }}({{ selectedFulfillments.length }})
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile>
                        <v-tooltip bottom>
                          <template v-slot:activator="tooltip">
                            <div v-on="tooltip.on">
                              <v-btn
                                :disabled="selectedFulfillments.length === 0"
                                :loading="reverseFulfillLoading"
                                @click="setOrderStatus(selectedFulfillments, 'open')"
                                flat
                                >{{ $t('reverse') }} ({{ selectedFulfillments.length }})</v-btn
                              >
                            </div>
                          </template>
                          {{ $t('moveToActive') }}
                        </v-tooltip>
                      </v-list-tile>
                      <v-list-tile>
                        <v-tooltip bottom>
                          <template v-slot:activator="tooltip">
                            <div v-on="tooltip.on">
                              <v-btn
                                :disabled="selectedFulfillments.length === 0"
                                :loading="closeFulfillLoading"
                                @click="setOrderStatus(selectedFulfillments, 'closed')"
                                flat
                                >{{ $t('close') }} ({{ selectedFulfillments.length }})</v-btn
                              >
                            </div>
                          </template>
                          {{ $t('moveToHistory') }}
                        </v-tooltip>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-layout>
              </v-flex>
              <v-flex xs2 md2 style="margin-right: 10px;">
                <v-select
                  v-model="store"
                  :label="$t('store')"
                  :items="stores"
                  item-text="accountName"
                  item-value="accountId"
                  clearable
                />
              </v-flex>
              <v-flex xs2 md2 style="margin-right: 10px;">
                <v-select
                  v-model="orderStatus"
                  :label="$t('status')"
                  :items="fulfillmentOrderStatuses"
                  item-text="label"
                />
              </v-flex>
              <v-flex xs4 md2>
                <v-text-field
                  append-icon="filter_list"
                  :label="$t('search')"
                  single-line
                  hide-details
                  v-model="filter"
                  clearable
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout justify-start>
              <v-flex class="success--text caption" xs2>
                <span class="realtime-border px-1">{{ $t('realTIME') }}</span>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="headers"
              :search="filter"
              :items="fulfillmentOrders"
              item-key="_indexKey"
              v-model="selectedFulfillments"
              select-all="blue"
              :expand="expand"
              :pagination.sync="pagination"
              :rows-per-page-items="rowPerPage"
            >
              <template v-slot:items="props">
                <td class="checkbox-align-center" @click="props.selected = !props.selected">
                  <v-layout>
                    <v-checkbox
                      @click.stop="
                        () => {
                          props.selected = !props.selected
                        }
                      "
                      :value="props.selected"
                      primary
                      hide-details
                    ></v-checkbox>
                  </v-layout>
                </td>
                <td class="text-xs-left">
                  <OrderDetail
                    :orderId="props.item.orderName || props.item.orderId"
                    :platform="props.item.platform"
                    :messages="props.item.messages || []"
                    :storeName="props.item.storeName"
                  />
                  <v-layout justify-start wrap align-start>
                    <span
                      >{{ $t('orderDate') }}: {{ toTimestampString(props.item.purchaseDate) }}</span
                    >
                  </v-layout>
                  <v-layout justify-start wrap align-start>
                    <span
                      >{{ $t('processDate') }}:
                      {{ toTimestampString(props.item.processTime) }}</span
                    >
                  </v-layout>
                </td>
                <td class="text-xs-left">
                  <v-flex row v-for="(item, index) in props.item.items" :key="item.sku + index">
                    <ProductWidget
                      :name="item.productName"
                      :sku="[item.sku]"
                      :quantityShipped="item.quantityShipped"
                      :quantityPurchased="item.quantityPurchased"
                      :status="item.productStatus"
                    />
                  </v-flex>
                </td>
                <td class="text-xs-left">
                  <v-layout>
                    <strong>{{ props.item.buyerName }}</strong>
                  </v-layout>
                  <v-layout> {{ props.item.recipientName }} </v-layout>
                  <v-layout> {{ props.item.shipAddress1 + props.item.shipAddress2 }} </v-layout>
                  <v-layout>
                    {{ props.item.shipCity }} - {{ props.item.shipState }} -
                    {{ props.item.shipPostalCode }}
                  </v-layout>
                  <v-layout> {{ props.item.buyerPhoneNumber }} </v-layout>
                </td>
                <td class="text-xs-left">
                  <v-layout>
                    {{ props.item.shipServiceLevel }} /
                    {{ props.item.isBusinessOrder ? $t('business') : $t('other') }}
                  </v-layout>
                </td>
                <td class="text-xs-left">
                  <v-tooltip top v-if="props.item.cancelState">
                    <template v-slot:activator="tooltip">
                      <div v-on="tooltip.on">
                        <p style="color: red; font-weight: bold">
                          {{ $t(props.item.cancelState) }}
                        </p>
                      </div>
                    </template>
                    {{ $t('canceledOrder') }}
                  </v-tooltip>
                  {{ $t(props.item.status) }}
                </td>
                <td class="text-xs-left">
                  <v-layout wrap>
                    <v-flex
                      v-for="shipment in props.item.shipments.reduce((preVal, curVal) => {
                        if (
                          !preVal.some(
                            ({ trackingNumber }) => curVal.trackingNumber && trackingNumber === curVal.trackingNumber
                          )
                        )
                          preVal.push(curVal)
                        return preVal
                      }, [])"
                      :key="shipment.key || shipment.labelKey + shipment.orderItemId"
                    >
                      <LabelTrackingDetailWidget
                        :trackingNumber="
                          getShipmentTracking(shipment) !== 'No tracking'
                            ? getShipmentTracking(shipment)
                            : ''
                        "
                        :status="
                          getOrderTrackingDetail(props.item, (shipment.trackingNumber || '').trim())
                            .status
                        "
                        :carrier="
                          getOrderTrackingDetail(props.item, (shipment.trackingNumber || '').trim())
                            .carrier
                        "
                        :details="
                          getOrderTrackingDetail(props.item, (shipment.trackingNumber || '').trim())
                            .trackingDetails
                        "
                      >
                        <span v-if="shipment.key">
                          <strong>{{ shipment.key }}</strong> -
                          {{ getShipmentTracking(shipment) }} -
                          {{ shipment.status }}
                        </span>
                      </LabelTrackingDetailWidget>
                    </v-flex>
                  </v-layout>
                </td>
              </template>
            </v-data-table>
          </div>
          <PaginationController
            v-if="item === 'history' && currentTab === 'history'"
            v-model="historyOrders"
            getDataActionName="getHistoryOrdersPagination"
            haveStartDate
            isShowStartBtn
            isPagination
            :startDate="startDate"
            :refresh="searchOrderHistoryRefresh"
            :startDateLabel="$t('processStartDate')"
            :searchBoxLabel="$t('orderId/sku')"
            :historyLimit="historyLimit"
            :actionPredicates="[
              {
                field: 'keywords',
                compare: 'array-contains',
                value: (platform || searchOrderHistory || selectWord || '').toLowerCase(),
              },
            ]"
          >
            <template v-slot:beforeMenu>
              <v-layout row nowrap>
                <v-flex md3 mr-1>
                  <v-select
                    :items="[
                      { name: $t('keyword'), value: 'keyword' },
                      { name: $t('platform'), value: 'platform' },
                      { name: $t('label'), value: 'label' },
                      { name: $t('shipment'), value: 'shipping' },
                    ]"
                    item-value="value"
                    item-text="name"
                    v-model="orderHistoryMode"
                    @change="
                      e => {
                        platform = ''
                        searchOrderHistory = ''
                        if (e === 'label' || e === 'shipping') {
                          selectWord = e
                        } else {
                          selectWord = ''
                        }
                      }
                    "
                    label="Search Mode"
                  ></v-select>
                </v-flex>
                <v-flex v-if="orderHistoryMode === 'keyword'" md4>
                  <v-text-field
                    :label="$t('orderId/sku')"
                    v-model="searchOrderHistory"
                    @keyup.enter="
                      () => {
                        searchOrderHistoryRefresh = !searchOrderHistoryRefresh
                      }
                    "
                    clearable
                  />
                </v-flex>
                <v-flex v-if="orderHistoryMode === 'platform'" md4>
                  <v-autocomplete
                    :items="platforms"
                    item-value="value"
                    item-text="name"
                    v-model="platform"
                    :label="$t('platform')"
                  />
                </v-flex>
              </v-layout>
            </template>
            <template v-slot:afterDate>
              <v-flex xs3>
                <v-btn
                  small
                  color="primary"
                  :disabled="!selectedHistoryOrders.length"
                  @click="exportOrdersShippingConfirm({ orders: selectedHistoryOrders })"
                >
                  {{ $t('exportSelectedOrders') }}({{ selectedHistoryOrders.length }})
                </v-btn>
              </v-flex>
              <v-flex xs3>
                <v-switch :label="isMergePDF ? 'PDF' : 'ZIP'" v-model="isMergePDF"></v-switch>
              </v-flex>
              <v-flex xs3>
                <LoaderButton
                  isSmall
                  :buttonText="
                    $t('downloadLabelsNum', { selectedLabelsLength: selectedHistoryOrders.length })
                  "
                  :promiseAwait="downloadSelectedOrderLabels"
                  :disabled="selectedHistoryOrders.length === 0"
                />
              </v-flex>
            </template>
            <template v-slot:dataTable>
              <v-data-table
                :headers="headers"
                :items="historyOrders"
                hide-actions
                item-key="orderId"
                v-model="selectedHistoryOrders"
                select-all="blue"
                :expand="expand"
              >
                <template v-slot:items="props">
                  <td class="checkbox-align-center" @click="props.selected = !props.selected">
                    <v-layout>
                      <v-checkbox
                        @click.stop="
                          () => {
                            props.selected = !props.selected
                          }
                        "
                        :value="props.selected"
                        primary
                        hide-details
                      ></v-checkbox>
                    </v-layout>
                  </td>
                  <td class="text-xs-left">
                    <OrderDetail
                      :orderType="props.item.isMPS"
                      :orderId="props.item.orderName || props.item.orderId"
                      :platform="props.item.platform"
                      :messages="props.item.messages || []"
                      :storeName="props.item.storeName"
                    />
                    <v-layout justify-start wrap align-start>
                      <span
                        >{{ $t('orderDate') }}:
                        {{ toTimestampString(props.item.purchaseDate) }}</span
                      >
                    </v-layout>
                    <v-layout justify-start wrap align-start>
                      <span
                        >{{ $t('processDate') }}:
                        {{ toTimestampString(props.item.processTime) }}</span
                      >
                    </v-layout>
                  </td>
                  <td class="text-xs-left">
                    <v-flex row v-for="(item, index) in props.item.items" :key="item.sku + index">
                      <ProductWidget
                        :name="item.productName"
                        :sku="[item.sku]"
                        :quantityShipped="item.quantityShipped"
                        :quantityPurchased="item.quantityPurchased"
                      />
                    </v-flex>
                  </td>
                  <td class="text-xs-left">
                    <v-layout>
                      <strong>{{ props.item.buyerName }}</strong>
                    </v-layout>
                    <v-layout>
                      {{ props.item.recipientName }}
                    </v-layout>
                    <v-layout>
                      {{ props.item.shipAddress1 + props.item.shipAddress2 }}
                    </v-layout>
                    <v-layout>
                      {{ props.item.shipCity }} - {{ props.item.shipState }} -
                      {{ props.item.shipPostalCode }}
                    </v-layout>
                    <v-layout>
                      {{ props.item.buyerPhoneNumber }}
                    </v-layout>
                  </td>
                  <td class="text-xs-left">
                    <v-layout>
                      {{ props.item.shipServiceLevel }} /
                      {{ props.item.isBusinessOrder ? $t('business') : $t('other') }}
                    </v-layout>
                  </td>
                  <td class="text-xs-left">
                    <v-layout wrap>
                      <v-flex
                        v-for="shipment in props.item.shipments.reduce((preVal, curVal) => {
                          if (
                            !preVal.some(
                              ({ trackingNumber }) => trackingNumber === curVal.trackingNumber
                            )
                          )
                            preVal.push(curVal)
                          return preVal
                        }, [])"
                        :key="shipment.key || shipment.labelKey + shipment.orderItemId"
                      >
                        <LabelTrackingDetailWidget
                          :trackingNumber="
                            getShipmentTracking(shipment) !== 'No tracking'
                              ? getShipmentTracking(shipment)
                              : ''
                          "
                          :status="
                            getOrderTrackingDetail(
                              props.item,
                              (shipment.trackingNumber || '').trim()
                            ).status
                          "
                          :carrier="
                            getOrderTrackingDetail(
                              props.item,
                              (shipment.trackingNumber || '').trim()
                            ).carrier
                          "
                          :details="
                            getOrderTrackingDetail(
                              props.item,
                              (shipment.trackingNumber || '').trim()
                            ).trackingDetails
                          "
                        >
                          <span v-if="shipment.key">
                            <strong>{{ shipment.key }}</strong> -
                            {{ getShipmentTracking(shipment) }} -
                            {{ shipment.status }}
                          </span>
                        </LabelTrackingDetailWidget>
                      </v-flex>
                    </v-layout>
                  </td>
                </template>
              </v-data-table>
            </template>
          </PaginationController>
          <PaginationController
            v-if="item === 'canceled' && currentTab === 'canceled'"
            v-model="historyCancelOrders"
            ref="getHistoryCanceledOrdersPagination"
            getDataActionName="getHistoryCanceledOrdersPagination"
            haveStartDate
            isShowStartBtn
            isPagination
            :startDate="startDate"
            :historyLimit="historyLimit"
          >
            <template v-slot:beforeMenu>
              <v-layout>
                <v-btn
                  small
                  color="primary"
                  :loading="deleteLoading"
                  :disabled="!selectedHistoryCanceledOrders.length"
                  @click="deleteOrder(selectedHistoryCanceledOrders, 'getHistoryCanceledOrdersPagination', true)"
                >
                  {{ $t('delete') }}({{ selectedHistoryCanceledOrders.length }})
                </v-btn>
                <v-btn
                  small
                  color="primary"
                  :loading="restoreLoading"
                  :disabled="!selectedHistoryCanceledOrders.length"
                  @click="restoreOrder(selectedHistoryCanceledOrders, 'getHistoryCanceledOrdersPagination')"
                >
                  {{ $t('restore') }}({{ selectedHistoryCanceledOrders.length }})
                </v-btn>
              </v-layout>
            </template>
            <template v-slot:afterDate>
              <v-flex xs3>
                <v-btn
                  small
                  color="primary"
                  :disabled="!selectedHistoryCanceledOrders.length"
                  @click="exportOrdersShippingConfirm({ orders: selectedHistoryCanceledOrders })"
                >
                  {{ $t('exportSelectedOrders') }}({{ selectedHistoryCanceledOrders.length }})
                </v-btn>
              </v-flex>
            </template>
            <template v-slot:dataTable>
              <v-data-table
                :headers="headers"
                :items="historyCancelOrders"
                hide-actions
                item-key="orderId"
                v-model="selectedHistoryCanceledOrders"
                select-all="blue"
                :expand="expand"
              >

              <template v-slot:items="props">
                <td
                  class="checkbox-align-center"
                  @click="!props.item.isDisabled && (props.selected = !props.selected)"
                >
                  <v-layout>
                    <v-checkbox
                      :disabled="props.item.isDisabled"
                      @click.stop="
                        () => {
                          props.selected = !props.selected
                        }
                      "
                      :value="props.selected"
                      primary
                      hide-details
                    ></v-checkbox>
                  </v-layout>
                </td>
                <td class="text-xs-left">{{ toTimestampString(props.item.purchaseDate) }}</td>
                <td class="text-xs-left">
                  <OrderDetail
                    :orderType="props.item.isMPS"
                    :storeName="props.item.storeName"
                    :orderId="props.item.orderName || props.item.orderId"
                    :platform="props.item.platform"
                    :messages="props.item.messages"
                    :orderStatus="props.item.cancelState"
                  />
                  <v-layout v-if="!!props.item.error" justify-start wrap align-start>
                    <span style="color: red;">Shipment Error: {{ props.item.error.message }}</span>
                  </v-layout>
                </td>
                <td class="text-xs-left">
                  <v-flex row v-for="(item, index) in props.item.items" :key="item.sku + index">
                    <ProductWidget
                      :name="item.productName"
                      :sku="[item.sku]"
                      :quantityShipped="item.quantityShipped"
                      :quantityPurchased="item.quantityPurchased"
                      :status="item.productStatus"
                      :isMatchingExactly="props.item.exactMatchTemplate"
                      @submit-quantity="(value) => updateQuantity(props.item.orderId, item.orderItemId, value)"
                      isSupportChanged
                    >
                      <template v-slot:sku>
                        <span class="ml-2"
                          ><a
                            @click="
                              () => {
                                filter = item.sku
                              }
                            "
                            >{{ item.sku }}</a
                          ></span
                        >
                      </template>
                    </ProductWidget>

                    <v-layout>
                      <v-flex class="text-sm-left"
                        >{{ $t('shipBy') }}: {{ toDateString(props.item.promiseDate) }}</v-flex
                      >
                    </v-layout>
                  </v-flex>
                </td>
                <td class="text-xs-left">
                  <v-layout>
                    <strong>{{ props.item.buyerName }}</strong>
                  </v-layout>
                  <v-layout>
                    {{ props.item.recipientName }}
                  </v-layout>
                  <v-layout>
                    {{ props.item.shipAddress1 + props.item.shipAddress2 }}
                  </v-layout>
                  <v-layout>
                    {{ props.item.shipCity }} - {{ props.item.shipState }} -
                    {{ props.item.shipPostalCode }}
                  </v-layout>
                  <v-layout>
                    {{ props.item.buyerPhoneNumber }}
                  </v-layout>
                </td>
                <td class="text-xs-left">
                  <v-layout>
                    <span
                      :style="`color: ${
                        props.item.shipServiceLevel === 'ShippingMethodExpress' ||
                        props.item.platform === 'Amazon' && props.item.shipServiceLevel  === 'NextDay'  ||
                        props.item.platform === 'Amazon' && props.item.shipServiceLevel === 'SecondDay'  ||
                        props.item.shipServiceLevel === 'Express'
                          ? 'red'
                          : 'black'
                      }`"
                      >{{ props.item.shipServiceLevel }}</span
                    >
                    <span>/{{ props.item.isBusinessOrder ? $t('business') : $t('other') }}</span>
                  </v-layout>
                </td>
                <td class="text-xs-center">
                  <v-btn icon flat dark color="primary" :loading="props.item.loading" @click="deleteOrder([props.item], 'getHistoryCanceledOrdersPagination')">
                    <v-icon>delete</v-icon>
                  </v-btn>
                  <v-btn icon flat dark color="primary" :loading="props.item.restoreLoading" @click="restoreOrder([props.item], 'getHistoryCanceledOrdersPagination')">
                    <v-icon>restore</v-icon>
                  </v-btn>
                </td>
            </template>
              </v-data-table>
            </template>
          </PaginationController>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
    <ModifyPkgSpecificationPopup
      v-model="revisePkgDialog"
      v-if="revisePkgDialog"
      :order.sync="currentRevisePkgOrder"
      @updateOrders="(order) => updateOrders(order)"
      @popupClose="currentRevisePkgOrder = {}"
    />
    <OrderAddShipment
      v-model="showAddShipmentDialog"
      v-if="showAddShipmentDialog"
      :selectedOrder="selectedOrder"
      :template="selectedTemplate"
    />
    <BuyShippingPopup
      v-model="buyShippingDialog"
      v-if="buyShippingDialog"
      :selectedOrders.sync="selectedOrders"
      @submitted="clearSelectedOrders"
    />
    <BuyLabelPopup
      v-model="buyLabelDialog"
      v-if="buyLabelDialog"
      :selectedOrders.sync="selectedOrders"
      @submitted="clearSelectedOrders"
    />
    <LabelTemplatePopup
      v-model="createTemplateDialog"
      v-if="createTemplateDialog"
      :initTemplate="templateInEdit"
    />
    <EditBuyShippingPopup
      v-model="editBuyShippingDialog"
      v-if="editBuyShippingDialog"
      :selectedOrders.sync="editSelectedOrders"
      @submitted="clearEditSelectedOrders"
      :editSelectedItems="editSelectedItems"
    />

    <FormSubmitPopup
      :title="$t('exportOrders')"
      :value="exportOrdersPopup.show"
      :rightMethod="exportOrdersShipping"
      :rightButtonText="$t('export')"
      @popupClose="exportOrdersPopup.show = false"
      small
      hasAlert
    >
      <template v-slot:input>
        <v-layout>
          <v-flex>
            <v-select
              v-model="exportOrdersPopup.status"
              :label="$t('status')"
              :items="orderStatuses"
              item-text="label"
            />
          </v-flex>
        </v-layout>
        <v-layout justify-space-between>
          <v-flex md4>
            <v-select
              v-model="exportOrdersPopup.dateType"
              :label="$t('dateType')"
              :items="dateTypes"
              item-text="label"
            />
          </v-flex>
          <v-flex md7>
            <DatePicker
              v-model="exportOrdersPopup.dates"
              :isShowIcon="false"
              :label="$t('date')"
              range
              :max="dateMax"
              :min="dateMin"
            />
          </v-flex>
        </v-layout>
      </template>
    </FormSubmitPopup>

    <FormSubmitPopup
      :title="$t('remarkOrder')"
      v-model="remarkOrderPopup.show"
      :rightMethod="remarkOrder"
      :rightButtonText="$t('submit')"
      @popupClose="remarkOrderPopup.show = false"
      small
      hasAlert
    >
      <template v-slot:input>
        <v-layout>
          <v-flex>
            <v-textarea
              v-if="remarkOrderPopup.order"
              :label="$t('remark')"
              hide-details
              v-model="remarkOrderPopup.order.remark"
              clearable
            ></v-textarea>
          </v-flex>
        </v-layout>
      </template>
    </FormSubmitPopup>

    <SplitOrderPopup ref="splitOrderPopup" />
  </v-container>
</template>

<script>

import LoaderButton from './LoaderButton'
import PaginationController from './PaginationController'
import UploadFileWidget from './UploadFileWidget'
import { timeTools, checkRules, measurementTools, cloneDeep, addMonths, addDays } from '../utils/tools'
import OrderAddShipment from './OrderAddShipment'
import ProductWidget from './ProductWidget'
import OrderDetail from './OrderDetail'
import BuyShippingPopup from './BuyShippingPopup'
import BuyLabelPopup from './BuyLabelPopup'
import LabelTemplatePopup from './LabelTemplatePopup'
import LabelTrackingDetailWidget from './LabelTrackingDetailWidget'
import { getFileUrl } from '@/utils/dbAccessor'
import ModifyPkgSpecificationPopup from './ModifyPkgSpecificationPopup'
import LabelAddressWidget from './LabelAddressWidget'
import EditBuyShippingPopup from './EditBuyShippingPopup.vue'
import DatePicker from './DatePicker.vue'
import FormSubmitPopup from './FormSubmitPopup'
import SplitOrderPopup from './SplitOrderPopup.vue'

export default {
  name: 'TenantOrder',
  components: {
    LoaderButton,
    PaginationController,
    UploadFileWidget,
    OrderAddShipment,
    ProductWidget,
    OrderDetail,
    BuyShippingPopup,
    LabelTemplatePopup,
    BuyLabelPopup,
    LabelTrackingDetailWidget,
    ModifyPkgSpecificationPopup,
    LabelAddressWidget,
    EditBuyShippingPopup,
    DatePicker,
    FormSubmitPopup,
    SplitOrderPopup
  },
  data () {
    const now = new Date()
    return {
      filter: '',
      pagination: {
        sortBy: ''
      },
      rowPerPage: [20, 50, 100, {text: this.$t('all'), value: -1}],
      archivedShipments: [],
      historyLimit: 20,
      rawOrders: '',
      uploadedFiles: [],
      displayDetail: false,
      removeAfterCancel: true,
      clearFiles: false,
      selectedOrders: [],
      selectedOrder: {},
      showAddShipmentDialog: false,
      historyOrders: [],
      historyCancelOrders: [],
      expand: false,
      buyShippingDialog: false,
      buyLabelDialog: false,
      loading: false,
      alert: false,
      alertType: 'success',
      alertMsg: '',
      createTemplateDialog: false,
      templateInEdit: {},
      platforms: [
        { name: `-- ${this.$t('all')} --`, value: '' },
        { name: 'Amazon', value: 'Amazon' },
        { name: 'eBay', value: 'ebay' },
        { name: 'Walmart', value: 'walmart' },
        { name: 'Newegg', value: 'newegg' },
        { name: 'Customize', value: 'customize' },
        { name: 'Tik Tok', value: 'tiktok' },
        { name: 'Shopify', value: 'shopify' },
        { name: 'Shein', value: 'shein' },
        { name: 'Shein_self', value: 'shein_self' }
      ],
      platform: '',
      searchOrderHistory: '',
      searchOrderHistoryRefresh: false,
      orderHistoryMode: 'keyword',
      selectWord: '',
      selectedTemplate: {},
      selectedHistoryOrders: [],
      selectedHistoryCanceledOrders: [],
      buyLabelDialogRunning: false,
      buyShippingDialogRunning: false,
      isMergePDF: false,
      storePullOrders: [],
      selectedFulfillments: [],
      pullOrderCDTime: 15,
      reverseFulfillLoading: false,
      closeFulfillLoading: false,
      processEcomLoading: false,
      revisePkgDialog: false,
      currentRevisePkgOrder: {},
      selectedShipmentOrders: [],
      processOrderShipmentLoading: false,
      editBuyShippingDialog: false,
      editSelectedOrders: [],
      editSelectedItems: [],
      exportOrdersPopup: {
        show: false,
        dates: [new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000), now],
        status: '',
        dateType: 'createTime',
        loading: false
      },
      startDate: new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000),
      remarkOrderPopup: {
        show: false,
        order: null
      },
      deleteLoading: false,
      sortTable: {
        sort: true,
        type: 'asc',
        param: 'purchaseDate'
      },
      dates: [addMonths(now, -1), now],
      activeDateMax: now.toISOString(),
      activeDateMin: addDays(addMonths(now, -1), -1).toISOString(),
      cancelLoading: false,
      restoreLoading: false,
      tab: 0,
      orderStatus: '',
      store: ''
    }
  },
  mixins: [timeTools, checkRules, measurementTools],
  computed: {
    currentTab () {
      return this.tabs[this.tab]
    },
    tabs () {
      const tabs = [
        'active',
        'pendingShipment',
        'fulfillment',
        'history',
        'canceled'
      ]
      if (this.isOrgLabel) {
        tabs.splice(1, 1)
      }
      return tabs
    },
    isOrgLabel () {
      const { user = {} } = this.$store.getters
      const { roles = [] } = user
      const isOrgLabel = roles.includes('orgLabel')
      return isOrgLabel
    },
    orderStatuses () {
      return [
        { label: this.$t('all'), value: '' },
        { label: this.$t('open'), value: 'open' },
        { label: this.$t('Ready'), value: 'ready' },
        { label: this.$t('closed'), value: 'closed' },
        { label: this.$t('partial'), value: 'partial' },
        { label: this.$t('Archived'), value: 'archived' },
        { label: this.$t('canceled'), value: 'canceled' }
      ]
    },
    fulfillmentOrderStatuses () {
      return [
        { label: this.$t('all'), value: '' },
        { label: this.$t('readyToFulfillment'), value: 'readyToFulfillment' },
        { label: this.$t('pendingFulfillment'), value: 'pendingFulfillment' }
      ]
    },
    dateTypes () {
      return [
        { label: this.$t('createTime'), value: 'createTime' },
        { label: this.$t('processTime'), value: 'processTime' },
        { label: this.$t('statusUpdateTime'), value: 'lastModifiedTime' }
      ]
    },
    dateMin () {
      const [startDate, endDate] = this.exportOrdersPopup.dates
      if (startDate && endDate) return undefined
      if (startDate) {
        const monthTime = 31 * 60 * 60 * 24 * 1000
        const time = startDate.getTime() - monthTime
        return new Date(time).toISOString()
      }
      return undefined
    },
    dateMax () {
      const [startDate, endDate] = this.exportOrdersPopup.dates
      const now = new Date()
      if (startDate && endDate) return now.toISOString()
      if (startDate) {
        const monthTime = 31 * 60 * 60 * 24 * 1000
        const time = startDate.getTime() + monthTime
        return now.getTime() < time ? now.toISOString() : new Date(time).toISOString()
      }
      return now.toISOString()
    },
    enabledSelectedShipmentOrders () {
      return this.selectedShipmentOrders.filter(order => !order.isDisabled)
    },
    isMPSOrder () {
      return this.selectedOrders.every(order => order.isMPS)
    },
    selectedMPSOrdersLen () {
      return this.selectedOrders.filter(order => order.isMPS).length
    },
    selectedFilteredOrders: {
      get: function () {
        return this.selectedOrders
      },
      set: function (val) {
        if (val.length === 0) {
          this.orders.forEach(order => {
            order.isDisabled = false
          })
          this.selectedOrders = []
        } else if (val.length === 1 && !val[0].isDisabled) {
          this.orders.forEach((order) => {
            val[0].isMPS = val[0].isMPS || false
            let { isMPS = false } = order
            if (isMPS === val[0].isMPS) {
              order.isDisabled = false
            } else if (isMPS !== val[0].isMPS) {
              order.isDisabled = true
            }
          })
          let exist = false
          this.selectedOrders.forEach((order, index) => {
            if (order.orderId === val[0].orderId) {
              this.selectedOrders = this.selectedOrders.filter(order => order.orderId === val[0].orderId).filter(item => this.filter ? this.filterSeletedOrders(item) : true)
              exist = true
            }
          })
          !exist && this.selectedOrders.push(val[0])
        } else if (val.every(order => !order.isDisabled && order.isMPS === val[0].isMPS) && val.length !== this.orders.length) {
          this.selectedOrders = val.filter(item => !item.isDisabled).filter(item => this.filter ? this.filterSeletedOrders(item) : true)
        } else {
          if ((this.selectedOrders.length && this.isMPSOrder) || this.orders.every(item => item.isMPS)) {
            val.forEach(order => {
              if (order.isMPS && this.selectedOrders.length < 5) {
                if (!this.selectedOrders.some(({orderId}) => orderId === order.orderId)) this.selectedOrders.push(order)
              }
            })
            this.selectedOrders = this.selectedOrders.filter(item => this.filter ? this.filterSeletedOrders(item) : true)
          } else {
            this.selectedOrders = val.filter(item => !item.isDisabled && !item.isMPS).filter(item => this.filter ? this.filterSeletedOrders(item) : true)
            val.forEach(order => {
              if (order.isMPS) {
                order.isDisabled = true
              }
            })
          }
        }
      }
    },
    pullOrderUpdateLoading () {
      if (this.isDisabledPullOrder) return false
      return this.storePullOrders.some(storePullOrder => new Date(storePullOrder?.orderLastUpdateTime || new Date('2022-01-24')).getTime() < new Date(storePullOrder?.orderLastRequestTime || new Date('2021-12-09')).getTime())
    },
    fulfillmentOrders () {
      const time = new Date().getTime()
      const orders = this.$store.getters.fulfillmentOrders
        .filter(order => {
          const valid = !(order.status === 'partial' && order.shipments.every(shipment => shipment.status === 'closed'))
          return valid &&
          (this.orderStatus ? order.status === this.orderStatus : true) &&
          (this.store ? order.storeId === this.store : true)
        }) || []
      orders.forEach(order => {
        let _indexKey = `${order.orderId}_${time}`
        order._indexKey = _indexKey
      })
      return orders
    },
    shipmentOrders () {
      const activeOrders = this.originOrders
      const fulfillmentOrder = this.fulfillmentOrders
      const orders = activeOrders.concat(fulfillmentOrder)
      return this.$store.getters.pendingOrdersTask.map(order => {
        const matchedOrder = orders.find(item => item.orderId === order.orderId)
        if (matchedOrder) {
          order = Object.assign({}, matchedOrder, order)
        }
        return order
      })
    },
    isDisabledPullOrder () {
      return this.storePullOrders.length === 0
    },
    pullOrderLastTimeDisabled () {
      return this.storePullOrders.some(storePullOrder => +new Date() < new Date(storePullOrder?.orderLastRequestTime || new Date('2021-12-09')).getTime() + (1000 * 60 * 15))
    },
    stores () {
      return this.$store.getters.stores
        .filter(item => item.status === 'active' && item.isAuthorize)
    },
    originOrders () {
      return this.$store.getters.activeOrders || []
    },
    orders () {
      const time = new Date().getTime()
      let orders = this.originOrders.map(order => {
        const exactlyMatchedTemplateName = this.correctMatchedTemplate(order.items)
        if (exactlyMatchedTemplateName) {
          order.matchedTemplateName = exactlyMatchedTemplateName
          order.exactMatchTemplate = true
        } else {
          const adaptedTemplateName = this.findCorrectTemplate(order.items)
          if (adaptedTemplateName) {
            order.matchedTemplateName = adaptedTemplateName
            order.exactMatchTemplate = false
          } else {
            order.matchedTemplateName = ''
            order.exactMatchTemplate = true
          }
        }
        let _indexKey = `${order.orderId}_${time}`
        order._indexKey = _indexKey
        order.updateDate = order.updateDate || order.purchaseDate
        return order
      }).filter(order => {
        const { purchaseDate } = order
        const purchaseDateTime = new Date(purchaseDate).getTime()
        const [min, max] = this.dates
        const inDates = new Date(max || new Date()).getTime() >= purchaseDateTime && new Date(min).getTime() <= purchaseDateTime
        if (!inDates) return false
        const targetShipment = this.shipmentOrders.find(shipment => shipment.orderId === order._key && ['pending', 'failed'].includes(shipment.processStatus))
        return !targetShipment
      })

      const { sort, param, type } = this.sortTable
      if (sort) {
        orders.sort((a, b) => {
          const preTime = +new Date(a[param])
          const curTime = +new Date(b[param])
          return type === 'desc' ? curTime - preTime : preTime - curTime
        })
      }
      if (this.storePullOrders.length) {
        orders = orders.filter(order => this.storePullOrders.some(storePullOrder => order.storeId === storePullOrder?.accountId))
      }
      return orders
    },
    shipmentHeaders () {
      return [
        { text: this.$t('orderDetail'), value: 'sku', align: 'left', sortable: false, width: '15%' },
        { text: this.$t('from'), value: 'isExpedited', align: 'left', sortable: false, width: '15%' },
        { text: this.$t('to'), value: 'shippingService', align: 'left', sortable: false, width: '15%' },
        { text: this.$t('info'), value: 'error', align: 'left', sortable: false, width: '25%' },
        { text: this.$t('status'), value: 'taskStatus', align: 'left', sortable: false },
        { text: this.$t('action'), value: '', align: 'left', sortable: false, width: '100px' }]
    },
    headers () {
      switch (this.tab) {
        case 0 :
          return [
          // { sortable: false },
            { text: this.$t('orderDate'), value: 'orderId', align: 'left', sortable: true, width: '10%' },
            { text: this.$t('orderDetail'), value: 'sku', align: 'left', sortable: false, width: '15%' },
            { text: this.$t('productInfo'), value: 'orderName', align: 'left', sortable: false },
            { text: this.$t('buyerInfo'), value: 'isExpedited', align: 'left', sortable: false },
            { text: this.$t('serviceLevel/AddressType'), value: 'keywordsForSearch', align: 'left', sortable: false },
            { text: this.$t('template'), value: 'templateName', align: 'center', sortable: false },
            { text: this.$t('actions'), value: 'products[0].upc', align: 'center', sortable: false, width: '10%' }
          ]
        case 1 :
          return [
            { text: this.$t('orderDetail'), value: 'sku', align: 'left', sortable: false, width: '15%' },
            { text: this.$t('productInfo'), value: 'orderName', align: 'left', sortable: false },
            { text: this.$t('buyerInfo'), value: 'isExpedited', align: 'left', sortable: false },
            { text: this.$t('serviceLevel/AddressType'), value: 'keywordsForSearch', align: 'left', sortable: false },
            { text: this.$t('status'), value: 'status', align: 'left', sortable: false, width: '10%' },
            { text: this.$t('shipment'), value: 'shipments', align: 'left', sortable: false }
          ]
        case 2 :
          return [
            { text: this.$t('orderDetail'), value: 'sku', align: 'left', sortable: false, width: '15%' },
            { text: this.$t('productInfo'), value: 'orderId', align: 'left', sortable: false },
            { text: this.$t('buyerInfo'), value: 'orderName', align: 'left', sortable: false },
            { text: this.$t('serviceLevel/AddressType'), value: 'keywordsForSearch', align: 'left', sortable: false },
            { text: this.$t('shipment'), value: 'shipments', align: 'left', sortable: false, width: '20%' }
          ]
        case 4 :
          return [
          // { sortable: false },
            { text: this.$t('orderDate'), value: 'orderId', align: 'left', sortable: true, width: '10%' },
            { text: this.$t('orderDetail'), value: 'sku', align: 'left', sortable: false, width: '15%' },
            { text: this.$t('productInfo'), value: 'orderName', align: 'left', sortable: false },
            { text: this.$t('buyerInfo'), value: 'isExpedited', align: 'left', sortable: false },
            { text: this.$t('serviceLevel/AddressType'), value: 'keywordsForSearch', align: 'left', sortable: false },
            { text: this.$t('actions'), value: '', align: 'center', sortable: false, width: '10%' }
          ]
      }
    },
    skuToProductIdMap () {
      return this.$store.getters.skuToProductIdMap
    },
    shipmentToTrackingMap () {
      return this.$store.getters.shipmentToTrackingMap
    },
    hasSameProductId () {
      let set = new Set()
      this.selectedOrders.forEach(order => {
        let productId = this.skuToProductIdMap.get(order.sku)
        if (set.has(productId)) {
          return true
        }
        set.add(productId)
      })
      return false
    },
    isFromSameOrder () {
      let set = new Set()
      this.selectedOrders.forEach(order => {
        set.add(order.orderId)
        if (set.size > 1) return false
      })
      return true
    },
    hasUnknownSku () {
      let set = new Set()
      this.selectedOrders.forEach(order => {
        let productId = this.skuToProductIdMap.get(order.sku)
        if (set.has(productId)) {
          return true
        }
        set.add(productId)
      })
      return false
    },
    errorAlert () {
      return !this.isFromSameOrder || this.hasSameProductId
    },
    errorMessage () {
      if (this.errorAlert) {
        if (!this.isFromSameOrder) {
          return this.$t('orderNotFromSameOrderWarning')
        }
        return this.$t('orderFromSameOrderWarning')
      }
      return ''
    },
    templates () {
      return this.$store.getters.templates
    },
    orderQtyLimit () {
      return this.$store.getters.tenant.orderRTLimitMax || 1000
    }
  },
  mounted () {
    this.isMergePDF = window.localStorage.getItem('isMergePDF' + this.$store.getters.uid) === 'true'
  },
  watch: {
    buyShippingDialog (val) {
      if (!val) {
        this.orders.forEach(order => {
          order.isDisabled = false
        })
      }
    },
    fulfillmentOrders (val) {
      if (this.selectedFulfillments.length > 0) {
        let reloadSelectedOrder = []
        this.selectedFulfillments.forEach(order => {
          val.forEach(fulfillmentOrder => {
            if (order.orderId === fulfillmentOrder.orderId) {
              reloadSelectedOrder.push(fulfillmentOrder)
            }
          })
        })
        this.selectedFulfillments = reloadSelectedOrder
      }
    },
    stores (val, old) {
      this.storePullOrder = val.find(item => item.accountId === this.storePullOrder?.accountId) || {}
    },
    isMergePDF (val) {
      window.localStorage.setItem('isMergePDF' + this.$store.getters.uid, val)
    },
    tab () {
      this.selectedOrders = []
      this.selectedHistoryOrders = []
      this.selectedFulfillments = []
      this.selectedFilteredOrders = []
    },
    filter () {
      this.selectedOrders = []
      this.selectedFulfillments = []
    }
  },
  methods: {
    filterSeletedOrders (item) {
      return item.orderId.includes(this.filter) || item.sku.includes(this.filter) || item.orderName.includes(this.filter)
    },
    async remarkOrder () {
      try {
        await this.$store.dispatch('remarkOrder', { order: this.remarkOrderPopup.order })
      } catch (err) {
        alert(err.message)
      }
    },
    showRemarkOrderPopup (item) {
      this.remarkOrderPopup = {
        show: true,
        order: { ...item }
      }
    },
    showSplitOrderPopup (item) {
      const $splitOrderPopup = this.$refs.splitOrderPopup
      $splitOrderPopup && $splitOrderPopup.showPopup(item)
    },
    updateOrders (order) {
      const { isMPS: orderIsMPS, orderId, packaging: { length, width, height, weight } } = order
      if (this.selectedOrders.length) {
        this.selectedOrders.forEach((item, index) => {
          const { isMPS = false } = item
          if (item.orderId === orderId) {
            if (orderIsMPS !== isMPS) {
              this.selectedOrders.splice(index, 1)
            } else {
              this.selectedOrders.splice(index, 1, {...order, length, width, height, weight})
            }
          }
        })
      }
    },
    showRevisePkg (order) {
      order = cloneDeep(order)
      order.packagingSpecs = order.packagingSpecs?.map(pkg => {
        return {
          ...pkg,
          ...this.convertPackagingSize(pkg, order.isMeasurementMetric),
          weight: this.convertWeight(pkg.weight, order.isMeasurementMetric)
        }
      }) || []
      this.currentRevisePkgOrder = Object.assign({
        packaging: (() =>
          (order.length || order.width || order.height) && order.isMeasurementMetric !== undefined
            ? order.isMPS
              ? Object.assign(this.convertPackagingSize(order, order.isMeasurementMetric), order.packagingSpecs[0], { skus: order.packagingSpecs[0].skus || [] })
              : {
                skus: order.skus ? [order.skus] : [],
                ...this.convertPackagingSize(order, order.isMeasurementMetric),
                weight: this.convertWeight(order.weight, order.isMeasurementMetric),
                packageQuantity: 1
              }
            : {})(),
        isOz: false
      }, order)
      this.revisePkgDialog = true
    },

    setOrderStatus (fulfillments, status) {
      if (!confirm(this.$t('confirmMoveOrder', {status: status === 'open' ? this.$t('active') : this.$t('history')}))) return
      if (status === 'open') {
        this.reverseFulfillLoading = true
        let isShipped = false
        fulfillments.forEach(fulfillment => {
          isShipped = fulfillment.shipments.some(shipment => shipment.status === 'shipped')
          fulfillment.shipments.forEach(shipment => {
            if (shipment.key) {
              shipment.trackingNumber = (this.$store.getters.shipments.find(({_key}) => _key === shipment.key) || {}).trackingNum || shipment.trackingNumber
            }
          })
        })
        if (isShipped) {
          alert(this.$t('reverseFulfillAlert'))
          this.reverseFulfillLoading = false
          return
        }
      } else {
        this.closeFulfillLoading = true
      }
      let payload = { fulfillments, status }
      this.$store.dispatch('setOrderStatus', payload)
        .catch((error) => {
          alert(error.message)
          console.error(error)
        })
        .finally(() => {
          if (status === 'open') {
            this.reverseFulfillLoading = false
          } else {
            this.closeFulfillLoading = false
          }
        })
    },
    ecomRequest (payload) {
      return this.$store.dispatch('processEcomRequest', payload)
        .then((res) => {
          this.$store.dispatch('showToast', {info: this.$t(res), level: 'success'})
        })
        .catch((error) => {
          let errorMessage = error.toString().split('Error: ')[1]
          this.$store.dispatch('showToast',
            {
              info: this.$t(`EcomRequestError.${errorMessage.split(',')[0]}`, {message: errorMessage.split(',')[1] || ''}),
              level: 'error'
            })
        })
        .finally(() => {
          this.processEcomLoading = false
        })
    },
    async retryOrderShipment (orders) {
      if (!confirm('Are you sure you want to retry the shipment?')) return
      if (this.processOrderShipmentLoading) return
      this.processOrderShipmentLoading = true

      try {
        await this.$store.dispatch('retryOrderShipment', orders.map(order => order._key))

        orders.forEach((order, index) => {
          const target = this.selectedShipmentOrders.find(({_key}) => _key === order._key)
          if (target) {
            this.$set(target, 'isDisabled', true)
          }
        })
        this.selectedShipmentOrders = []
        this.$store.dispatch('showToast', {info: this.$t('retryOrderShipmentSuccess'), level: 'success'})
      } catch (error) {
        this.$store.dispatch('showToast', {info: error.message, level: 'error'})
        throw error
      } finally {
        this.processOrderShipmentLoading = false
      }
    },
    async updateQuantity (orderId, orderItemId, changedQty) {
      const order = this.orders.find(order => order.orderId === orderId)
      if (!order) {
        this.$store.dispatch('showToast', {info: this.$t('orderNotFound'), level: 'error'})
        throw Error()
      }
      const orderItem = order.items.find(item => item.orderItemId === orderItemId)
      const items = cloneDeep(order.items)
      const originalQty = orderItem.originalQty || orderItem.quantityPurchased
      try {
        if (!['CUSTOMIZE', 'TIKTOK'].includes(order.platform?.toUpperCase?.())) {
          this.$store.dispatch('showToast', {info: 'Only supports tiktok and customize platform', level: 'error'})
          throw Error()
        }
        if (!orderItem) {
          this.$store.dispatch('showToast', {info: 'order item not found', level: 'error'})
          throw Error()
        }

        if ((changedQty < originalQty || changedQty < orderItem.quantityShipped) && ['TIKTOK'].includes(order.platform?.toUpperCase?.())) {
          this.$store.dispatch('showToast', {info: this.$t('quantityExceeds'), level: 'error'})
          throw Error()
        }
        await this.$store.dispatch('updateOrderItemQuantity', {orderId: order._key, orderItemId, originalQty, changedQty})
          .then(() => {
            this.selectedOrders = this.selectedOrders.filter(order => order.orderId !== orderId)
            this.$store.dispatch('showToast', {info: this.$t('success'), level: 'success'})
          })
      } catch (error) {
        if (orderItem) {
          this.$set(order, 'items', [])
          requestAnimationFrame(() => {
            this.$set(order, 'items', items)
          })
        }
        throw error
      }
    },
    markFulfillment (fulfillments) {
      if (!confirm(this.$t('confirmFulfillment'))) return
      this.processEcomLoading = true
      let isShipmentsLabelPending = fulfillments.some(item => {
        return item.shipments.some(shipment => {
          if (shipment.key) {
            return shipment.status === 'pending' &&
              this.$store.getters.shipments.find(({_key}) => _key === shipment.key)?.trackingNum === ''
          } else {
            return shipment.trackingNumber === ''
          }
        })
      })

      if (isShipmentsLabelPending) {
        this.$store.dispatch('showToast', {info: this.$t('labelProcessToast'), level: 'error'})
        this.processEcomLoading = false
        return
      }
      let platformEqual = fulfillments.every(({platform}) => platform === fulfillments[0].platform)
      if (!platformEqual) {
        this.$store.dispatch('showToast', {info: this.$t('fulfillInconsistent'), level: 'error'})
        this.processEcomLoading = false
        return
      }
      let isCanceled = fulfillments.some(fulfillment => fulfillment.cancelState ||
        fulfillment.items.some(item => item.productStatus && item.productStatus === 'canceled'))
      if (isCanceled) {
        this.$store.dispatch('showToast', {info: this.$t('orderIsCanceled'), level: 'error'})
        this.processEcomLoading = false
        return
      }

      let deduplication = {}
      let data = []
      fulfillments.forEach(item => {
        const orderItemIds = [...(item.orderItemIds || [])]
        item.shipments.reduce((preVal, shipment) => {
          if (shipment.status === 'closed') return preVal
          let getShipment
          let isCreateShipment = false
          if ((shipment.key && shipment.status === 'pending')) {
            getShipment = this.$store.getters.shipments.find(({_key}) => _key === shipment.key)
            isCreateShipment = true
          }
          let obj = {
            orderId: item.orderId,
            originOrderId: item.originOrderId || item.orderId,
            accountId: item.storeId,
            data: {
              lineItems: item.shipments.reduce((arr, lineItem) => {
                if (!lineItem.quantity) return null
                const orderItem = item.items.find(row => row.orderItemId === lineItem.orderItemId)
                if (lineItem.key && lineItem.status === 'pending') {
                  if (isCreateShipment && getShipment && getShipment.trackingNum) {
                    if (['shein', 'shein_self'].includes(item.platform)) {
                      const key = shipment.key || shipment.labelKey
                      const itemKey = lineItem.key || lineItem.labelKey
                      if (
                        key === itemKey
                      ) {
                        const allOrderItemIds = orderItem.orderItemIds || [orderItem.orderItemId]
                        const ids = allOrderItemIds.filter(id => !orderItemIds.includes(id)).slice(0, lineItem.quantity)
                        orderItemIds.push(...ids)
                        arr.push(...ids.map(id => {
                          return {
                            lineItemId: id,
                            unitOfMeasurement: item.unitOfMeasurement || 'EA',
                            quantity: 1,
                            total: orderItem.quantityPurchased
                          }
                        }))
                      }
                    } else {
                      arr.push(
                        {
                          lineItemId: lineItem.orderItemId,
                          unitOfMeasurement: item.unitOfMeasurement || 'EA',
                          quantity: lineItem.quantity,
                          total: orderItem.quantityPurchased
                        }
                      )
                    }
                  }
                } else {
                  if (lineItem.trackingNumber === shipment.trackingNumber && shipment.status !== 'closed') {
                    if (['shein', 'shein_self'].includes(item.platform)) {
                      const key = shipment.key || shipment.labelKey
                      const itemKey = lineItem.key || lineItem.labelKey
                      if (key === itemKey) {
                        const allOrderItemIds = orderItem.orderItemIds || [orderItem.orderItemId]
                        const ids = allOrderItemIds.filter(id => !orderItemIds.includes(id)).slice(0, lineItem.quantity)
                        orderItemIds.push(...ids)
                        arr.push(...ids.map(id => {
                          return {
                            lineItemId: id,
                            unitOfMeasurement: item.unitOfMeasurement || 'EA',
                            quantity: 1,
                            total: orderItem.quantityPurchased
                          }
                        }))
                      }
                    } else {
                      arr.push(
                        {
                          lineItemId: lineItem.orderItemId,
                          unitOfMeasurement: item.unitOfMeasurement || 'EA',
                          quantity: lineItem.quantity,
                          total: orderItem.quantityPurchased
                        }
                      )
                    }
                  }
                }
                return arr
              }, []).filter(Boolean),
              shippedDate: isCreateShipment ? getShipment.createTime.toISOString() : new Date(shipment.shipDate).toISOString(),
              shippingCarrierCode: isCreateShipment ? (getShipment.labels.find(({orderId}) => orderId.includes(shipment.key)) || {}).carrier || getShipment.carrier || shipment.carrier || shipment.carrierName : shipment.carrier || shipment.carrierName,
              shippingMethod: item.shipServiceLevel || 'Value',
              trackingNumber: isCreateShipment ? getShipment.trackingNum : shipment.trackingNumber
            }
          }
          if (['shein', 'shein_self'].includes(item.platform)) {
            if (!deduplication[obj.data.trackingNumber] && !shipment.status !== 'closed') {
              deduplication[obj.data.trackingNumber] = true
              preVal.push(obj)
              data.push(obj)
            } else if (deduplication[obj.data.trackingNumber] && !shipment.status !== 'closed') {
              const target = data.find(row => {
                return row.orderId === obj.orderId && row.data.trackingNumber === obj.data.trackingNumber
              })
              target.data.lineItems.push(...obj.data.lineItems)
            }
          } else {
            if (!deduplication[obj.data.trackingNumber] && shipment.status !== 'closed') {
              deduplication[obj.data.trackingNumber] = true
              preVal.push(obj)
              data.push(obj)
            }
          }
          return preVal
        }, [])
      })
      let payload = {
        fulfillments: data,
        type: 'fulfillment',
        platform: fulfillments[0].platform,
        tenantKey: this.$store.getters.activeOrganization,
        countryCode: 'US'
      }
      this.ecomRequest(payload)
    },
    pullOrders (stores) {
      this.processEcomLoading = true
      return Promise.all(stores.map(store => {
        let { platform, accountId } = store
        let payload = {
          type: 'orders',
          platform,
          accountId
        }

        return this.ecomRequest(payload)
      }))
    },
    showTemplateDialog (item) {
      this.createTemplateDialog = true
      this.templateInEdit = {sku: item.items[0].sku}
    },
    uploadOrders () {
      this.loading = true
      this.alert = false
      this.alertType = 'success'
      this.alertMsg = ''
      if (!this.uploadedFiles.length) return Promise.resolve()
      return this.$store.dispatch('uploadOrders', {files: this.uploadedFiles})
        .then((rtn) => {
          this.alert = true
          let errors = rtn.data.filter(item => item.errorMessage)
          let orderQty = rtn.data.reduce((acc, item) => {
            if (item.qty) {
              return acc + item.qty
            }
            return acc
          }, 0)
          if (errors.length > 0) {
            this.alertType = 'error'
            this.alertMsg = errors.map(err => this.$t('uploadFileNameFailed', { name: err.fileName }) + `\nError: ${err.errorMessage}`).join('\n')
          } else {
            this.alertType = 'success'
            this.alertMsg = this.$t('uploadFileNameSuccess', {
              orderQty,
              platform: rtn.data[0].platform
            })
          }
        })
        .catch((error) => {
          this.alert = true
          this.alertType = 'error'
          this.alertMsg = error.message
        })
        .finally(() => {
          this.loading = false
          this.clearFiles = !this.clearFiles
        })
    },
    async cancelOrder (item) {
      if (item.loading) return
      if (!confirm(this.$t('confirmCancel', { name: this.$t('order') }))) return Promise.resolve()
      try {
        item.loading = true
        await this.$store.dispatch('cancelOrders', { orders: [item] })
        item.loading = false
      } catch (err) {
        alert(err.message)
        item.loading = false
      }
    },
    async cancelOrders (items) {
      const targets = items.filter(item => !item.loading)
      if (!targets.length) return
      if (!confirm(this.$t('confirmCancel', { name: this.$t('order') }))) return Promise.resolve()
      try {
        this.cancelLoading = true
        targets.forEach(item => { item.loading = true })
        await this.$store.dispatch('cancelOrders', { orders: items })
        targets.forEach(item => { item.loading = false })
        this.cancelLoading = false
      } catch (err) {
        alert(err.message)
        targets.forEach(item => { item.loading = false })
        this.cancelLoading = false
      }
    },
    async deleteOrder (items, refName, isBatch = false) {
      if (isBatch && this.deleteLoading) {
        return
      }
      if (!confirm(this.$t('confirmDelete', { name: this.$t('order') }))) return Promise.resolve()
      const targets = items.filter(item => !item.loading)
      try {
        if (isBatch) {
          this.deleteLoading = true
        }
        targets.forEach(item => { item.loading = true })
        await this.$store.dispatch('deleteOrders', {orders: targets})
        targets.forEach(item => { item.loading = false })
        if (isBatch) {
          this.deleteLoading = false
        }
        if (refName) {
          this.$refs[refName][0] && this.$refs[refName][0].onDateSubmit()
        }
      } catch (err) {
        alert(err.message)
        targets.forEach(item => { item.loading = false })
        if (isBatch) {
          this.deleteLoading = false
        }
      }
    },
    async restoreOrder (items, refName) {
      if (!confirm(this.$t('confirmRestore', { name: this.$t('order') }))) return Promise.resolve()
      const targets = items.filter(item => !item.restoreLoading)
      try {
        this.restoreLoading = true
        targets.forEach(item => { item.restoreLoading = true })
        await this.$store.dispatch('restoreOrders', {orders: targets})
        targets.forEach(item => { item.restoreLoading = false })
        if (refName) {
          this.$refs[refName][0] && this.$refs[refName][0].onDateSubmit()
        }
        this.restoreLoading = false
      } catch (err) {
        alert(err.message)
        targets.forEach(item => { item.restoreLoading = false })
        this.restoreLoading = false
      }
    },
    batchCancel () {
      if (!confirm(this.$t('confirmCancel/Archive', { name: this.$t('order') }))) return Promise.resolve()
      const promises = [
        this.$store.dispatch('cancelOrders', {orders: this.selectedOrders.filter(order => !order.items.some(item => item.quantityShipped > 0))}),
        this.$store.dispatch('archiveOrder', this.selectedOrders.filter(order => order.items.some(item => item.quantityShipped > 0)))
      ]
      return Promise.all(promises)
    },
    async archiveOrder (item) {
      if (item.archiveLoading) return
      if (!confirm(this.$t('confirmArchiveOrders'))) return Promise.resolve()
      try {
        item.archiveLoading = true
        await this.$store.dispatch('archiveOrder', [item])
        item.archiveLoading = false
      } catch (err) {
        alert(err.message)
        item.archiveLoading = false
      }
    },
    cancelDetail (item) {
      this.displayDetail = false
      if (this.removeAfterCancel) {
        this.$store.dispatch('cancelErrorMsg', item)
      }
    },
    sortOrders (name) {
      const { param, type } = this.sortTable
      const payload = {
        param: name,
        sort: true
      }
      if (param === name) {
        payload.type = type === 'desc' ? 'asc' : 'desc'
      } else {
        payload.type = 'desc'
      }
      this.sortTable = payload
      if (this.selectedOrders.length) {
        this.$nextTick(() => {
          const { page } = this.pagination
          const start = (page - 1) * this.selectedOrders.length
          this.selectedOrders = this.orders.slice(start, start + this.selectedOrders.length)
        })
      }
    },
    toggleAll () {
      const filterItems = this.$refs.activeOrders[0].filteredItems
      // const { page, rowsPerPage } = this.pagination
      // const start = (page - 1) * rowsPerPage
      if (this.selectedOrders.length) this.selectedOrders = []
      else {
        this.selectedOrders = this.orders.filter(item => {
          return filterItems.some(row => row._key === item._key)
        })
      }
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    showAddShipmentSingle (item) {
      this.selectedOrder = item
      this.showAddShipmentDialog = true
      this.selectedTemplate = this.templates.find(template => item.items.some(obj => obj.sku === template.sku))
    },
    delayExec (flag, excutor) {
      this[flag] = true
      setTimeout(() => { this[flag] = false }, 500 + this.selectedOrders.length * 150)
      setTimeout(() => excutor(), 200)
    },
    showBuyShippingDialog (isMPS = false) {
      this.delayExec('buyShippingDialogRunning', () => {
        if (this.selectedOrders.length > 5 && isMPS) return alert(this.$t('supportMaximumNumOrders', { num: 5 }))
        if (this.selectedOrders.length > 100) return alert(this.$t('supportMaximumNumOrders', { num: 100 }))
        // !isMPS && (this.selectedOrders = this.selectedOrders.filter(order => order.items.length === 1))
        this.buyShippingDialog = true
      })
    },
    showBuyLabelDialog (isMPS = false) {
      this.delayExec('buyLabelDialogRunning', () => {
        if (this.selectedOrders.length > 5 && isMPS) return alert(this.$t('supportMaximumNumOrders', { num: 5 }))
        // if (this.selectedOrders.length > 20) return alert(this.$t('supportMaximumNumOrders', { num: 20 }))
        this.buyLabelDialog = true
      })
    },
    showExportOrdersPopup () {
      this.exportOrdersPopup.show = true
    },
    async exportOrdersShipping () {
      try {
        const [startDate, endDate] = this.exportOrdersPopup.dates
        const orders = await this.$store.dispatch('getOrdersPagination', {
          startDate,
          endDate,
          status: this.exportOrdersPopup.status,
          dateType: this.exportOrdersPopup.dateType
        })
        if (!orders.length) {
          alert('order is empty')
        }
        await this.exportOrdersShippingConfirm({
          orders,
          startDate,
          endDate
        })
        this.exportOrdersPopup.show = false
      } catch (err) {
        console.log(err.message)
        alert(err.message)
        this.exportOrdersPopup.loading = false
      }
    },
    exportOrdersShippingConfirm (payload) {
      return this.$store.dispatch('exportOrderShippingsConfirmFiles', payload)
    },
    downloadSelectedOrderLabels () {
      return this.$store.dispatch('downloadSelectedOrderLabels', {
        orders: this.selectedHistoryOrders,
        isMergePDF: this.isMergePDF
      })
    },
    getShipmentTracking (shipment) {
      const {key, trackingNumber} = shipment
      const target = this.$store.getters.shipments.find(({_key}) => _key === key) || {}
      return trackingNumber || target?.trackingNumbers?.join(',') || target.trackingNum ||
        'No tracking'
    },
    clearSelectedOrders () {
      this.selectedOrders = []
      this.selectedFilteredOrders = []
      this.selectedOrders = []
      this.orders.forEach(order => {
        order.isDisabled = false
      })
    },
    clearEditSelectedOrders () {
      this.editSelectedOrders = []
      this.editBuyShippingDialog = false
    },
    getOrderTrackingDetail (order, trackingNumber) {
      if (!trackingNumber || trackingNumber === 'No tracking') return {status: 'error', carrier: '', trackingDetails: []}
      return order.trackingDetailMap ?
        (order.trackingDetailMap[trackingNumber] || {status: 'error', carrier: '', trackingDetails: []}) :
        { status: 'error', carrier: '', trackingDetails: [] }
    },
    getStandTemplate (isMPS = false) {
      let xlsxUrl = 'templates/orders-Customize-template-200430.xlsx'
      isMPS && (xlsxUrl = 'templates/orders-MPS-Customize-template.xlsx')
      return getFileUrl(xlsxUrl)
        .then(url => window.open(url))
    },
    findCorrectTemplate (items) {
      const skuMatchedTemplates = this.templates.filter(template => items.some(item => template.sku?.split(',').includes(item.sku)))
      if (!skuMatchedTemplates.length) return ''
      const adapteOldData = skuMatchedTemplates.filter(template => +template.quantity === 1 || !template.quantity)
      return (adapteOldData.length ? adapteOldData[0].name : skuMatchedTemplates[0].name) || ''
    },
    correctMatchedTemplate (items) {
      const skuMatchedTemplates = this.templates.filter(template => items.some(item => template.sku?.split(',').includes(item.sku)))
      const exactlyMatchedTemplates = skuMatchedTemplates.filter(template => items.some(item => +item.quantityPurchased === +template.quantity || (+item.quantityPurchased === 1 && !template.quantity)))
      return (exactlyMatchedTemplates.length && exactlyMatchedTemplates[0].name) || ''
    },
    editLabel (item) {
      if (item.isDisabled) return
      const order = this.originOrders.find(order => order._key === item.orderId)
      if (!order) {
        alert('cant find this order, please create shipment by other order')
        return
      }
      this.editSelectedOrders = [order]
      this.editSelectedItems = [item]
      this.editBuyShippingDialog = true
    },
    async deleteShipmentTask (item) {
      if (item.isDisabled) return
      if (!confirm(`Do you confirm to delete the shipment task ?`)) return
      try {
        await this.$store.dispatch('deleteOrderShipmentTask', { shipmentTaskId: item._key })
      } catch (err) {
        alert(err.message)
      }
    }
  }
}
</script>

<style>
.active-headers {
  color: rgba(0, 0, 0, .54);
  font-weight: 500;
  font-size: 12px;
  padding: 0 12px;
}

.active-headers .header-date {
  cursor: pointer;
}
.active-headers .header-date:hover {
  transition: .3s;
  color: rgba(0, 0, 0, .87);
}
.active-headers .header-date .header-date-arrow-desc {
  transition: .3s;
  transform: rotate(180deg);
}
.v-overflow-btn  {
  margin-top: 0px
}
.checkbox-align-center .v-messages {
  min-height: 0px;
}

.checkbox-align-center .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0px;
}
.high_light_list {
  background-color : yellow
}
.loading {
  transform-origin: 50% 50%;
  animation: pullOrderLoading 3s infinite linear;
  -moz-animation: pullOrderLoading 3s infinite linear;
  -webkit-animation: pullOrderLoading 3s infinite linear;
  -o-animation: pullOrderLoading 3s infinite linear;
}
@keyframes pullOrderLoading {
  0% {
    -webkit-transform: rotate(0);
  }

  50% {
    -webkit-transform: rotate(180deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TenantOrder.vue